export default [

    //  vehicles  router
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "vehicles",
          layout: "dashboard",
        },
        path: "/vehicles",
        name: "vehicles",
        component: () => import("@/layouts/index/VehicleIndex.vue"),
        children: [
          {
            meta: {
              is_auth: true,
              is_admin: true,
              title: "vehicles **",
              layout: "dashboard",
            },
            path: "index",
            name: "vehicles-index",
            component: () => import("@/views/vehicles/Listing.vue"),
          },
          {
            meta: {
              is_auth: true,
              is_admin: true,
              title: "Effectué et enregistre la commande",
              layout: "dashboard",
            },
            path: "create",
            name: "vehicles-create",
            component: () => import("@/views/vehicles/Create.vue"),
          },
    
          {
            meta: {
              is_auth: true,
              is_admin: true,
              title: "Effectué et enregistre la commande",
              layout: "dashboard",
            },
            path: ":reference/details",
            name: "vehicles-details",
            component: () => import("@/views/vehicles/Details.vue"),
          },
        ],
      },
    
]